<app-grid [ngClass]="isRoadmapGridDisplayed ? 'show' : 'hide' " class="margin-left-112"
  [columns]="roadmapGridColumnDefs" [data]="this.sharedValue.selectedRoadmapsList"
  [gridConfigItems]="roadmapGridConfigItems" (onBtnClick)="configureRoadmaps()"
  (onCellClick)="fnOnGridCellClick($event)" [showKebabIcon]="false" 
  [searchDisabled]="isCloneMode"
  [enableBodyCellKeyboardNavigation]="true" [bodyOnlyTabNavigation]="true">
</app-grid>
<ng-container *ngIf="!isRoadmapGridDisplayed && !showHazardDetails && !isRoadmapHistoryDisplayed">
  <roadmap-view-create 
  [sectionList]="sectionList"
  [sectionDetails]="sectionDetails"
  [project_id]="projectId"
  [serviceMachineId]="serviceMachineId"
  [roadmapId]="roadmapId"
  [roadmapName]="roadmapName"
  [isReadonlyRoadmap]="isReadonlyRoadmap"
  [readOnlyRoadmapData]="readOnlyRoadmapData"
  [isCustom]="isCustom"
  [isMachineBased]="true"
  [isRoadmapCopied]="isCopiedRoadmap"
  (exitEvent)="fnExitEvent($event)"
  ></roadmap-view-create>  
</ng-container>
<ng-container  *ngIf="isRoadmapHistoryDisplayed && !isRoadmapGridDisplayed">
  <app-roadmap-history [historyData]="historyData" (exitEvent)="fnExitEvent($event)">
  </app-roadmap-history>
</ng-container>